import { Constants } from '@config/constants/constants.interface';
import { getConstants } from '@config/constants/get-constants';

export const constants: Constants = getConstants();
